/*
    Controller to launch the Go Live dialog used to create a Production & Fixture Device Group pairing.

    The dialog allows the user to input a name for the new factory fixture device group,
    to choose and input a new name for the production devicegroup,
    as well as select which production devicegroup will be it's Target Production Device Group.
    Confirm/Edit target settings for the new production devicegroup.
    Usage: 
        var globalCh = Radio.channel('global');
        globalCh.request('show_go_live_dialog', devicegroup);
    Arguments:
        devicegroup: Instance of v5 'devicegroup' type 'pre-factoryfixture_devicegroup'
*/

import Radio from 'backbone.radio';
import GoLiveDialog from '@/views/dialogs/go_live';
import PaginationControls from '@/views/pagination_controls';

    export default function show_go_live(options) {
        var globalCh = Radio.channel('global');
        var apiCh = Radio.channel('api');
        var product = undefined;

        if ( options.pre_factoryfixture_devicegroup && options.pre_factoryfixture_devicegroup.rel ) {
            product = options.pre_factoryfixture_devicegroup.rel.get('product');
        } else if (  options.pre_production_devicegroup && options.pre_production_devicegroup.rel ) {
            product = options.pre_production_devicegroup.rel.get('product');
        } else if ( options.development_devicegroup && options.development_devicegroup.rel ) {
            product = options.development_devicegroup.rel.get('product');
        }
        var devicegroups = apiCh.request('production_devicegroup');
        var pagination_controls = new PaginationControls({
            collection: devicegroups
        });

        var go_live_dialog = new GoLiveDialog({
            pagination_controls: pagination_controls,
            development_devicegroup: options.development_devicegroup,
            pre_factoryfixture_devicegroup: options.pre_factoryfixture_devicegroup,
            pre_dut_devicegroup: options.pre_dut_devicegroup,
            pre_production: options.pre_production_devicegroup,
            product: product,
            devicegroups: devicegroups,
        });

        devicegroups.fetch({
            remove: false,
            data: {
                'filter[product.id]': product.id
            },
        }).done(pagination_controls.update_prev_next_from_response)
        .then(function(){
            globalCh.request('showDialog', go_live_dialog);
        });
        
    }

